import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'linkPart',
  standalone: false
})
export class LinkPartPipe implements PipeTransform {
  transform(value: string, partIndex: number): string {
    const regEx = /<\/?a[^>]*>/g;
    const result = value.split(regEx)[partIndex];
    return result;
  }
}
